import { useAbility } from '@cast/shared-ability-data-access';

export const usePermitEditWorkload = () => {
  const permitEdit = useAbility().can('update', 'ClusterWorkloadAutoscaler');

  return {
    permitEdit,
  };
};
